import { APIUrls } from "../../Constants/ApiUrls";
// import { ISystemSetting } from "../../Models/ISystemSetting"; //Fix Warning Complaint Code:071225
// import { IUser, IUserEdit } from "../../Models/IUser"; //Fix Warning Complaint Code:071225
import { AjaxService, IAPIRequest, IAPIResponse } from "../AjaxService";

const GenericLogController = {
  Get: async (type: string, callback?: (response: IAPIResponse) => void) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.GENERIC_LOGS.GENERIC_LOGS_GET + "?type=" + type;
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  Add: async (
    type: string,
    content: string,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.GENERIC_LOGS.GENERIC_LOGS_ADD;
    request.method = "POST";
    request.payload = { type, content };
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
};

export default GenericLogController;
